export default "<h1>Font OT 基础图标</h1>\n<p>2O3T-UI 基础图标库，我们还在持续补充中。</p>\n"